/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./overviewTable.vue?vue&type=template&id=13032af4&scoped=true"
import script from "./overviewTable.vue?vue&type=script&lang=js"
export * from "./overviewTable.vue?vue&type=script&lang=js"
import style0 from "./overviewTable.vue?vue&type=style&index=0&id=13032af4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13032af4",
  null
  
)

export default component.exports